/* eslint-disable */
export default {
  logging: 'Iniciando sesión…',
  logCall: 'Registrar llamada',
  editLog: 'Editar registro',
  select: 'Seleccionar una grabación que coincida',
  OnHold: 'En espera',
  Ringing: 'Llamando',
  CallConnected: 'Llamada conectada',
  unknownUser: 'Usuario desconocido',
  unknownNumber: 'Anónimo',
  unavailable: 'No disponible',
  viewDetails: 'Ver detalles',
  addEntity: 'Crear nuevo',
  addLog: 'Registro',
  text: 'Mensaje',
  call: 'Llamar',
  missedCall: 'Perdida',
  inboundCall: 'Entrante',
  outboundCall: 'Saliente',
  answeredBy: 'Atendida por',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
